import React from "react";
import { motion } from "framer-motion";
import HeroHexagon from "../HeroHexagon";

const PrivacyPolicy = () => {
  const textAnimate = {
    hidden: { opacity: 0, y: -100 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        ease: "easeInOut",
        duration: 0.8,
      },
    },
  };
  return (
    <>
      <div className="hero is-flex is-center dir-column ">
        <div className="container">
          <div className="hero-content clr-white">
            <motion.div
              className="content"
              initial="hidden"
              whileInView={"visible"}
              viewport={{ once: false, amount: 0.1 }}
              transition={{ staggerChildren: 1 }}
            >
              <motion.h5 className="fw-600 " variants={textAnimate}>
                <span className="line-shape pb-12 line-shape_left">
                  Legal
                </span>
              </motion.h5>

              <motion.h1 className="my-32 fs-h3" variants={textAnimate}>
                Privacy <span className="italic">Policy</span>
              </motion.h1>
              <motion.p className="fw-400" variants={textAnimate}>
                Last updated: March 2026
              </motion.p>
            </motion.div>
            <HeroHexagon />
          </div>
        </div>
      </div>
      <section className="about">
        <div className="container">
          <div className="about-content">
            <h5 className="clr-secondary mb-16">1. Overview</h5>
            <p className="mb-32">
              9Feathers ("we", "us", "our") respects your privacy. This policy explains what information we collect, how we use it, and your rights regarding that information.
            </p>

            <h5 className="clr-secondary mb-16">2. Information We Collect</h5>
            <p className="mb-16">
              We collect minimal information necessary for business communication:
            </p>
            <ul className="mb-16">
              <li><strong>Contact form submissions:</strong> Name, email address, phone number, and message content when you voluntarily submit our contact form.</li>
              <li><strong>Business correspondence:</strong> Information exchanged during project discussions, contracts, and ongoing service delivery.</li>
            </ul>
            <p className="mb-32">
              We do not collect payment information through this website. All billing is handled offline under signed agreements.
            </p>

            <h5 className="clr-secondary mb-16">3. How We Use Your Information</h5>
            <p className="mb-16">We use the information we collect solely to:</p>
            <ul className="mb-32">
              <li>Respond to your inquiries</li>
              <li>Discuss potential project engagements</li>
              <li>Deliver contracted services</li>
              <li>Communicate about ongoing projects</li>
            </ul>

            <h5 className="clr-secondary mb-16">4. Data Sharing</h5>
            <p className="mb-32">
              We do not sell, trade, or share your personal information with third parties. Information may only be shared with third-party service providers who assist us in delivering contracted services, and only as specified in your service agreement.
            </p>

            <h5 className="clr-secondary mb-16">5. Data Retention</h5>
            <p className="mb-32">
              Contact form submissions are retained only as long as necessary to respond to your inquiry. Client project data is retained per the terms of the applicable service agreement.
            </p>

            <h5 className="clr-secondary mb-16">6. Cookies</h5>
            <p className="mb-32">
              This website does not use tracking cookies or third-party analytics. No personal data is collected automatically through your use of this website.
            </p>

            <h5 className="clr-secondary mb-16">7. Your Rights</h5>
            <p className="mb-32">
              You may request access to, correction of, or deletion of any personal information we hold about you by contacting us at the address below.
            </p>

            <h5 className="clr-secondary mb-16">8. Contact</h5>
            <p>
              For privacy-related inquiries, contact us at{" "}
              <a href="mailto:info@9feathers.app" className="clr-primary">info@9feathers.app</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
